var map = {
	"./01-01.mp3": 490,
	"./01-01__.mp3": 762,
	"./01-02.mp3": 763,
	"./01-03.mp3": 356,
	"./01-04.mp3": 357,
	"./01-05.mp3": 491,
	"./01-06.mp3": 764,
	"./01-07.mp3": 765,
	"./01-08.mp3": 766,
	"./01-09.mp3": 767,
	"./01-10.mp3": 768,
	"./01-11.mp3": 806,
	"./01-12.mp3": 1527,
	"./01-13.mp3": 1528,
	"./01-14.mp3": 807,
	"./04-01.mp3": 1529,
	"./04-02.mp3": 1530,
	"./04-03.mp3": 808,
	"./04.mp3": 1531,
	"./emotion-slow.mp3": 809,
	"./emotion.mp3": 1532,
	"./ex1-slow.mp3": 810,
	"./ex1.mp3": 1533,
	"./ex1_3_4-slow.mp3": 811,
	"./ex1_3_4.mp3": 1534,
	"./ex7-slow.mp3": 812,
	"./ex7.mp3": 1535,
	"./ex8-slow.mp3": 813,
	"./ex8.mp3": 1536,
	"./health-slow.mp3": 814,
	"./health.mp3": 1537,
	"./intoSleep.mp3": 499,
	"./life-cycle-slow.mp3": 815,
	"./life-cycle.mp3": 1538,
	"./life-slow.mp3": 816,
	"./life.mp3": 1539,
	"./natureFeedback.mp3": 1540,
	"./natureFeedbackEffect.mp3": 817,
	"./recognition-slow.mp3": 818,
	"./recognition.mp3": 1541,
	"./soundAlpha.mp3": 1542,
	"./soundAlpha1.mp3": 1543,
	"./soundAlpha2.mp3": 1544,
	"./soundAttemption.mp3": 769,
	"./soundAttemptionNew.mp3": 1545,
	"./soundBalance.mp3": 771,
	"./soundBalanceF.mp3": 1546,
	"./soundBalanceNew.mp3": 1547,
	"./soundConst.mp3": 770,
	"./soundConstNew.mp3": 1548,
	"./soundRest.mp3": 358,
	"./soundRestNew.mp3": 1549,
	"./view5-ex1-slow.mp3": 819,
	"./view8-ex1-slow.mp3": 820,
	"./view9-ex1-slow.mp3": 821
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1526;